import { render, staticRenderFns } from "./LinkModalPro.vue?vue&type=template&id=47e43042&"
import script from "./LinkModalPro.vue?vue&type=script&lang=js&"
export * from "./LinkModalPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports